import { createReturnStatement } from "@vue/compiler-core"

export default {
    namespaced: true,
    state: {
        elements: [],
        pageId: null
    },
    getters: {
        getElements(state) {
            return state.elements
        },
    },
    mutations: {
        SET_ELEMENTS(state, value) {
            state.elements = value
        },
        SET_PAGE_ID(state, value) {
            state.pageId = value
        },
    },
    actions: {
        updateElements({ commit }, data) {
            commit('SET_ELEMENTS', data)
        },
        cleanStore({ commit }) {
            commit('SET_ELEMENTS', {})
        },
        async deleteElement({ commit, state }, element) {
            const newElementsArray = state.elements.filter((stateElement) => element.id !== stateElement.id)
            commit('SET_ELEMENTS', newElementsArray)
        },
        async replaceElement({ commit, state }, element) {
            const newElementsArray = [];
            await Promise.all(state.elements.map(async (stateElement) => {
                if (element.id === stateElement.id) {
                    stateElement = element;
                }
                newElementsArray.push(stateElement);
            }))
            console.log('update one element', newElementsArray)
            commit('SET_ELEMENTS', newElementsArray)
        },
        async insertElement({ commit, state }, payload) {
            console.log('payload', payload);
            const newElement = payload.element,
                afterElementId =  parseInt(payload.after);
            const els = state.elements;
            const newElementsArray = [];
            let nextOrder = 1;

            console.log(afterElementId);

            if (0 === afterElementId) {
                newElement.order = 1;
                newElementsArray.push(newElement);
                nextOrder++;
            }

            await Promise.all(els.map(async (element) => {
                element.order = nextOrder;
                newElementsArray.push(element);
                nextOrder++;

                if (element.id === afterElementId) {
                    newElement.order = nextOrder;
                    newElementsArray.push(newElement);
                    nextOrder++;
                }
            }));
            console.log('update elements', newElementsArray)
            commit('SET_ELEMENTS', newElementsArray)

        },
    }
}